
import SubmitReviewForm from './review/SubmitReviewForm';

interface ReviewFormProps {
  initialCompany?: string;
}

const ReviewForm = ({ initialCompany = '' }: ReviewFormProps) => {
  return <SubmitReviewForm initialCompany={initialCompany} />;
};

export default ReviewForm;
